import React, { Component } from 'react'
import { graphql, Link } from 'gatsby'
import SEO from '../components/seo'
import Layout from '../components/layout'
import ServiceHero from '../components/service-hero'
import CTA from '../components/cta-bar'
import * as Markdown from 'react-markdown'
import styled from 'styled-components'
import Card from '../components/card'
import PhotoGalleryComponent from '../components/photo-gallery-component'
import SocialReviewsFullwidth from '../components/social-reviews-fullwidth'
import { TestimonialSection } from '../components/testimonial_video'
import { getSchemaSameAs } from '../helpers/schema-json'
import { intersperse } from '../helpers/react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const MainContentContainer = styled.div``
const SidebarContainer = styled.div``

const WhiteBGSection = styled.section`
  background: #f9f9f9;
  padding: 2.5em 1em;
  box-shadow: rgba(0, 0, 0, 0.03) 0px 2px 4px 0px;
`
// adds comma in a list by passing ", " as sep argument/parameter
class ServiceCityTemplate extends Component {
  render() {
    // console.log('this', this.props.pageContext)

    function parseContent(string, altCity) {
      if (string) {
        const newString = string.replace(/{{city}}/g, altCity ? altCity : city)
        const secondReplacement = newString.replace(
          /{{citySlug}}/g,
          (altCity ? altCity : city)
            .replace(/\./g, '')
            .toLowerCase()
            .replace(/\s/g, '-') + '-ca'
        )

        return secondReplacement
      }
    }

    let { pageContext } = this.props
    const city = pageContext.city
    let pageData = this.props.data.contentfulServiceAreaContent

    let citiesList = this.props.data.allContentfulServiceArea.edges
    let content = parseContent(pageData.content.content)
    let tidbits = ''
    tidbits = pageContext.tidbits
    let zipCodes = pageContext.zipCodes

    const TopBar = () => {
      //pageData has the data
      const topBar = pageData.topbar || []
      return topBar.map(({ id, title, cssClasses, content }) => (
        <section
          key={id}
          className={cssClasses}
          dangerouslySetInnerHTML={{ __html: content.content }}
        />
      ))
    }
    const { testimonials: testimonial_video_posts } =
      pageData.testimonialSection || { testimonials: [] }

    const SidebarColumn = () => {
      const sideBarCards = pageData.sidebar.map((sidebar, index) => {
        if (sidebar.__typename == 'ContentfulSidebar') {
          return <Card key={index} sidebar={sidebar} />
        } else if (sidebar.__typename == 'ContentfulSidebarCollection') {
          const innerCards = sidebar.sidebars.map((sidebar, index) => {
            return <Card key={'inner' + index} sidebar={sidebar} />
          })
          return innerCards
        } else return null
      })

      return sideBarCards
    }

    const schemaSameAs = getSchemaSameAs(
      this.props.data.site.siteMetadata.social
    )

    return (
      <>
        <Layout
          pageProps={this.props}
          footerLogoShowcase={pageData.footerLogoShowcase}
          customSchema
        >
          <SEO
            title={parseContent(pageData.seoTitle)}
            description={parseContent(pageData.metaDescription)}
            img={pageData.heroImage.gatsbyImageData.images.fallback.src}
          />
          <ServiceHero
            pageData={pageData}
            serviceTitle={parseContent(pageData.serviceTitle)}
            heroImage={pageData.heroImage}
            excerpt={parseContent(pageData.excerpt)}
            pageProps={this.props}
            badges={pageData.headerFeaturedBadges}
            specialOffer={parseContent(pageData.specialOffer)}
            offerDisclaimer={parseContent(pageData.offerDisclaimer)}
          />
          {pageData.socialReviewsFullWidth &&
          pageData.socialReviewsFullWidth.slug ? (
            <SocialReviewsFullwidth
              modalLinkTo={`/reviews/${pageData.socialReviewsFullWidth.slug}/`}
            />
          ) : null}

          {pageData.photoGalleryRef && pageData.photoGalleryRef.photos ? (
            <WhiteBGSection className="photogallerysec">
              <PhotoGalleryComponent
                gallery={pageData.photoGalleryRef}
                city={city}
                filters={this.props.pageContext.testimonialsAndProjectsFilters}
              />
            </WhiteBGSection>
          ) : null}

          <TopBar />
          <TestimonialSection
            testimonial_video_posts={testimonial_video_posts}
            filters={this.props.pageContext.testimonialsAndProjectsFilters}
          />

          <div className="container brand-padding-y">
            <div className="row">
              <MainContentContainer
                className={
                  pageData.sidebar
                    ? 'col-12 col-md-8 is-service-page'
                    : 'col-12 is-service-page'
                }
              >
                {' '}
                <div dangerouslySetInnerHTML={{ __html: content }} />
                {zipCodes ? (
                  <h3 className="servicedzip">
                    Serviced ZIP Codes:{' '}
                    {intersperse(
                      zipCodes.map((zipCode, i) => zipCode),
                      ', '
                    )}
                    {zipCodes.map((zipCode) => (
                      <script
                        type="application/ld+json"
                        dangerouslySetInnerHTML={{
                          __html: `
                            {
                              "@context": "https://www.schema.org",
                              "@type": "PostalAddress",
                              "addressLocality": "${city}",
                              "addressRegion": "CA",
                              "postalCode": "${zipCode}"
                            }
                           `,
                        }}
                      />
                    ))}
                  </h3>
                ) : null}
                <div className="pt-4 pb-5">
                  <h2>Other Service Areas</h2>
                  <ul className="flex flex-wrap list-none m-0">
                    {citiesList.map((item, i) => {
                      // Check for 'remodelexclude' market segment for specific slugs
                      const excludeForRemodel = ['dummy/']

                      if (
                        excludeForRemodel.includes(pageData.slug) &&
                        item.node.marketSegment.includes('remodelexclude')
                      ) {
                        return null
                      }

                      // List of slugs for kitchen and bathroom remodeling
                      const remodelingSlugs = [
                        'kitchen-remodeling/',
                        'kitchen-cabinets/',
                        'general-contractor/',
                        'home-additions/',
                        'roofing-contractor/',
                        'countertops/',
                        'bathroom-remodeling/',
                        'shower-replacement-installation/',
                      ]
                      // Check if the current slug is one of the remodeling slugs
                      // and if the market segment includes 'bayarea'
                      if (
                        remodelingSlugs.includes(pageData.slug) &&
                        item.node.marketSegment.includes('bayarea')
                      ) {
                        return null
                      }

                      return (
                        <li key={i} className="w-1/2 md:w-1/3 flex">
                          <div className="flex-shrink-0 pr-1">
                            <svg
                              className="h-6 w-6 text-green-500"
                              stroke="currentColor"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M5 13l4 4L19 7"
                              ></path>
                            </svg>
                          </div>
                          <Link
                            className="text-gray-800"
                            title={`${parseContent(
                              pageData.serviceTitle,
                              item.node.location
                            )}`}
                            to={`/cities/${item.node.slug}/${pageData.slug}`}
                          >
                            {item.node.location}
                          </Link>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </MainContentContainer>

              {pageData.sidebar ? (
                <SidebarContainer className="col-12 col-md-4">
                  <div className="aspect-ratio-box mb-4 rounded-lg shadow-md">
                    <iframe
                      className="aspect-ratio-box-inside projects-project"
                      src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCwXnoLHPbHNOjKkwCoFY8u4RHtqDGp8dM&q=${city}+CA`}
                      width="100%"
                      frameBorder={0}
                      height="400"
                      loading="lazy"
                    />
                  </div>
                  <SidebarColumn />

                  {/* Wrapping BlogSection inside a Card for styling consistency */}
                  {this.props.data.allContentfulBlogPost.edges.length > 0 && (
                    <Card
                      sidebar={{
                        title: 'From The Blog',
                        content: { content: 'blog' },
                      }}
                    >
                      {this.props.data.allContentfulBlogPost.edges.map(
                        ({ node }) => (
                          <BlogPostSideBarItem
                            key={node.id}
                            title={node.title}
                            slug={node.slug}
                            image={node.image}
                            publishDate={node.publishDate}
                            author={node.author.name}
                          />
                        )
                      )}
                    </Card>
                  )}
                </SidebarContainer>
              ) : (
                ''
              )}
            </div>
          </div>

          <hr />
          <div className="container mt-4 mb-8">
            <h4>
              Frequently Asked Questions about {pageData.serviceName} in {city}
            </h4>
            <section
              className="tidbitssec"
              dangerouslySetInnerHTML={{ __html: tidbits }}
            />
          </div>
          <CTA
            title={
              'Start Your ' +
              parseContent(pageData.serviceTitle) +
              ' Project Today!'
            }
            customTitle={parseContent(pageData.footerCallToActionHeading)}
            customDesc={parseContent(pageData.footerCallToActionDesc)}
            bgimage={pageData.footerCallToActionImg}
            serviceHeroImage={pageData.heroImage}
            btn={'Get Started!'}
            props={this.props}
          />
        </Layout>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `
            {
              "@context": "http://schema.org/",
              "@type": "service",
              "servicetype": "${this.props.pageContext.serviceTitle}",
              "provider": {
                  "@type": "organization",
                  "name": "${this.props.data.site.siteMetadata.title}",
                  "url": "${
                    this.props.data.site.siteMetadata.siteUrl +
                    this.props.location.pathname
                  }",
                  "logo": "https://images.ctfassets.net/79nimht05j33/5KXVC6MO76L5dlpGRcyHWe/a4aa833447743ec3de5a718d5b43fe0b/gvd-renovations-thumb2.jpeg",
                  "image": "https://images.ctfassets.net/79nimht05j33/4agtFJcDsqbN9D0ohWiaP3/30a086aa90f96cc841e72dfa66f0e019/gvd-renovations-thumb.jpg",
                  "address": {
                      "@type": "postaladdress",
                      "addresslocality": "${city}",
                      "addressregion": "CA",
                      "postalcode": "${this.props.pageContext.zipCode}"
                  },
                  "contactpoint": {
                      "@type": "contactpoint",
                      "contacttype": "customer support",
                      "telephone": "${
                        this.props.data.site.siteMetadata.companyInfo.phone
                      }",
                      "email": "${
                        this.props.data.site.siteMetadata.companyInfo.email
                      }"
                  },
                  "sameas": [${schemaSameAs.map((link) => `"${link}"`)}]
              },
              "areaserved": [{
                  "@type": "city",
                  "name": "${city}",
                  "@id": "https://en.wikipedia.org/wiki/${city.replace(
                    /\s/g,
                    '_'
                  )},_California"
              }],
              "hasoffercatalog": {
                  "@type": "offercatalog",
                  "name": "${this.props.pageContext.serviceTitle}",
                  "itemlistelement": [{
                      "@type": "offercatalog",
                      "name": "${this.props.pageContext.serviceTitle.toLowerCase()} services",
                      "itemlistelement": [
                        ${pageData.schemaItemOffered.map(
                          (item) =>
                            `{
                        "@type": "offer",
                        "itemoffered": {
                            "@type": "service",
                            "name": "${item.replace(/{{city}}/g, city)}"
                        }
                    }`
                        )}]
                  }]
              }
          }
        `,
          }}
        />
      </>
    )
  }
}

const BlogPostSideBarItem = ({
  title,
  slug,
  image,
  publishDate,
  author,
  page = 'blog',
  excerpt,
  className,
}) => {
  return (
    <Link to={`/${page}/${slug}`} className="flex mb-4 space-x-4" title={title}>
      <div className="w-24 h-24 flex-basis">
        <GatsbyImage
          image={getImage(image)}
          alt={title}
          className="rounded-lg"
        />
      </div>
      <div className="flex-1">
        <p className="pb-1 border-b block hover:text-gvd-green flex text-base md:text-sm font-semibold items-top mb-0 leading-tight text-custom-gray">
          {title}
        </p>
        <p className="text-xs text-gray-500 mb-0">
          {publishDate} by {author}
        </p>
      </div>
    </Link>
  )
}

const BlogSection = (props) => {
  const { edges: blogPosts } = props.data.allContentfulBlogPost

  if (!blogPosts.length) {
    return null
  }

  return (
    <div className="container mt-4">
      <h3>From The Blog</h3>
      <div className="grid grid-cols-2 gap-3">
        {blogPosts.map(({ node }) => (
          <BlogPostSideBarItem
            {...node}
            key={node.id}
            author={node.author.name}
          />
        ))}
      </div>
    </div>
  )
}

export default ServiceCityTemplate

export const pageQuery = graphql`
  query serviceCityQuery(
    $slug: String!
    $marketSegments: [String]
    $categorySlug: String
  ) {
    site {
      siteMetadata {
        title
        siteUrl
        companyInfo {
          phone
          email
        }
        social {
          guildquality
          facebook
          yelp
          instagram
          youtube
          google
          angies
          linkedin
          bbb
        }
      }
    }
    allContentfulBlogPost(
      filter: { category: { slug: { eq: $categorySlug } } }
      limit: 6
      skip: 6
      sort: { publishDate: DESC }
    ) {
      edges {
        node {
          id
          title
          slug
          publishDate(formatString: "MMMM Do, YYYY")
          image: heroImage {
            gatsbyImageData(
              height: 120
              width: 120
              aspectRatio: 1
              resizingBehavior: CROP
              cropFocus: CENTER
              quality: 70
              placeholder: NONE
            )
          }
          metaDescription
          author {
            name
          }
        }
      }
    }
    contentfulServiceAreaContent(slug: { eq: $slug }) {
      id
      serviceTitle
      serviceName
      seoTitle
      metaDescription
      slug
      excerpt
      specialOffer
      offerDisclaimer
      socialReviewsFullWidth {
        slug
      }
      testimonialSection {
        testimonials {
          id
          title
          projectReference {
            slug
          }
          video {
            id
            title
            file {
              url
              contentType
            }
          }
          thumbnail {
            gatsbyImageData(width: 600, quality: 90, placeholder: NONE)
          }
        }
      }
      photoGalleryRef {
        id
        title
        description {
          description
        }
        benefits {
          benefits
        }
        photos {
          id
          title
          gatsbyImageData(
            width: 150
            quality: 70
            aspectRatio: 1.26153846154
            placeholder: NONE
          )
          fullSize: gatsbyImageData(width: 1874, quality: 70, placeholder: NONE)
        }
      }
      headerFeaturedBadges {
        title
        gatsbyImageData(width: 300, placeholder: NONE)
      }
      heroImage {
        gatsbyImageData(width: 2000, quality: 70, placeholder: BLURRED)
      }
      content {
        content
      }
      footerLogoShowcase
      footerCallToActionHeading
      footerCallToActionDesc
      footerCallToActionImg {
        gatsbyImageData(width: 1800, placeholder: NONE)
      }
      topbar {
        id
        title
        content {
          id
          content
        }
        cssClasses
      }
      sidebar {
        __typename
        ... on ContentfulSidebar {
          id
          title
          content {
            id
            content
          }
          testimonialCategory {
            id
            name
          }
          cssClasses
        }
        ... on ContentfulSidebarCollection {
          sidebars {
            id
            title
            content {
              id
              content
            }
            testimonialCategory {
              id
              name
            }
            cssClasses
          }
        }
      }
      schemaItemOffered
    }
    allContentfulServiceArea(
      filter: { marketSegment: { in: $marketSegments } }
      sort: { fields: location }
    ) {
      edges {
        node {
          location
          slug
          marketSegment
          zipCodes
        }
      }
    }
  }
`
